import {
  buildPropertyDetailReturnState,
  getPropertyDetailPath,
  getPropertyDetailUrl,
  resolvePropertyDetailId,
  storePropertyDetailReturnState,
} from "./propertyDetailNavigation";

/**
 * Open the property detail page in a new browser tab.
 * `navigate` is accepted for call-site compatibility but is not used.
 */
export function openPropertyDetail(_navigate, property, returnState = {}) {
  const id = resolvePropertyDetailId(property);

  if (!id) {
    return false;
  }

  if (returnState && Object.keys(returnState).length) {
    storePropertyDetailReturnState(returnState);
  }

  const url = getPropertyDetailUrl(id);
  const opened = window.open(url, "_blank", "noopener,noreferrer");
  return opened !== null;
}

export { buildPropertyDetailReturnState, resolvePropertyDetailId, getPropertyDetailPath, getPropertyDetailUrl };
